import React from "react";
import { useStateContext } from "../contexts/ContextProvider";

const EditRoomForm = (props) => {
  const { room, roomError, duplicateNameError, handleChange, handleCheckbox } =
    props;
  const { leases } = useStateContext();

  return (
    <form className="grid justify-items-center mb-60">
      <label className="grid">
        Room Name:
        <input
          id="room-name"
          name="roomName"
          type="text"
          value={room.roomName}
          placeholder="Room Name"
          className={`w-80 border-gray-300 border-1 p-1 ${roomError.roomName}`}
          onChange={handleChange}
        />
        {duplicateNameError ? (
          <span className="text-red-500">This name is taken.</span>
        ) : (
          ""
        )}
      </label>
      <div className="flex">
        <label className={`grid mt-5 mr-4 ${roomError.rent}`}>
          Rent:
          <div className="relative">
            <div className="absolute left-1 top-1.5">$</div>
            <input
              id="rent"
              name="rent"
              type="tel"
              maxLength={5}
              value={room.rent}
              className={`w-36 border-gray-300 border-1 pl-4 py-1 ${roomError.rent}`}
              onChange={handleChange}
            />
          </div>
        </label>
        <label className="grid mt-5 ml-4">
          Security Deposit:
          <div className="relative">
            <div className="absolute left-1 top-1.5">$</div>
            <input
              id="security-dep"
              name="securityDep"
              type="tel"
              maxLength={5}
              value={room.securityDep}
              className="w-36 border-gray-300 border-1 pl-4 py-1"
              onChange={handleChange}
            />
          </div>
        </label>
      </div>
      <label className={`grid mt-5 ${roomError.shortDesc}`}>
        Title:
        <input
          id="short-desc"
          name="shortDesc"
          type="text"
          maxLength={70}
          placeholder="Short Description"
          value={room.shortDesc}
          className={`w-80 border-gray-300 border-1 p-1 ${roomError.shortDesc}`}
          onChange={handleChange}
        />
      </label>
      <label className={`grid mt-5 ${roomError.longDesc}`}>
        Description:
        <textarea
          id="long-desc"
          name="longDesc"
          type=""
          maxLength={1000}
          placeholder="Tell the world about this room."
          value={room.longDesc}
          className={`w-80 h-[200px] border-gray-300 border-1 p-1 ${roomError.longDesc}`}
          onChange={handleChange}
        />
      </label>
      {/* <label className="grid mt-5">
        Available On:
        <input
          id="available"
          name="available"
          type="date"
          value={room.available}
          className={`w-80 border-gray-300 border-1 ${roomError.shortDesc} p-1`}
          onChange={handleChange}
        />
      </label> */}
      {/* <div className="text-xl my-3">Options:</div> */}
      <div className="w-80 mt-5 px-1">
        <div className="grid grid-cols-2 gap-x-5 gap-y-3">
          <div className="flex justify-between items-center">
            <div>Furnished:</div>
            <input
              id="funished"
              name="isFurnished"
              type="checkbox"
              checked={room.isFurnished}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
          <div className="flex justify-between items-center">
            <div>Couples Ok:</div>
            <input
              id="couples-ok"
              name="couplesOk"
              type="checkbox"
              checked={room.couplesOk}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
          <div className="flex justify-between items-center">
            <div>Smoking Ok:</div>
            <input
              id="smoking-ok"
              name="smokingOk"
              type="checkbox"
              checked={room.smokingOk}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
          <div className="flex justify-between items-center">
            <div>Cannabis Ok:</div>
            <input
              id="cannabis-ok"
              name="cannabisOk"
              type="checkbox"
              checked={room.cannabisOk}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
          <div className="flex justify-between items-center">
            <div>Male Only:</div>
            <input
              id="male-only"
              name="maleOnly"
              type="checkbox"
              checked={room.maleOnly}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
          <div className="flex justify-between items-center">
            <div>Female Only:</div>
            <input
              id="female-only"
              name="femaleOnly"
              type="checkbox"
              checked={room.femaleOnly}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
          <div className="flex justify-between items-center">
            <div>Co-Ed:</div>
            <input
              id="is-co-ed"
              name="isCoEd"
              type="checkbox"
              checked={room.isCoEd}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
          <div className="flex justify-between items-center">
            <div>Private Bath:</div>
            <input
              id="private-bath"
              name="privateBath"
              type="checkbox"
              checked={room.privateBath}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
          <div className="flex justify-between items-center">
            <div>Dogs Ok:</div>
            <input
              id="dogs-ok"
              name="dogsOk"
              type="checkbox"
              checked={room.dogsOk}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
          <div className="flex justify-between items-center">
            <div>Cats Ok:</div>
            <input
              id="cats-ok"
              name="catsOk"
              type="checkbox"
              checked={room.catsOk}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
          <div className="flex justify-between items-center">
            <div>Laundry:</div>
            <input
              id="laundry"
              name="laundry"
              type="checkbox"
              checked={room.laundry}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
          <div className="flex justify-between items-center">
            <div>Wifi:</div>
            <input
              id="wifi"
              name="wifi"
              type="checkbox"
              checked={room.wifi}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
          <div className="flex justify-between items-center">
            <div>LGBTQ+ Friendly:</div>
            <input
              id="lgbt-freindly"
              name="lgbtFriendly"
              type="checkbox"
              checked={room.lgbtFriendly}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
          <div className="flex justify-between items-center">
            <div> Off-Street Parking:</div>
            <input
              id="parking"
              name="parking"
              type="checkbox"
              checked={room.parking}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
          <div className="flex col-span-2 justify-around items-center px-10">
            <div>Wheelchair Accessible:</div>
            <input
              id="accessible"
              name="isAccessible"
              type="checkbox"
              checked={room.isAccessible}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
        </div>
      </div>

      {leases.filter((x) => x.roomId === room.id).length > 0 &&
        leases.find((x) => x.roomId === room.id).status === "active" && (
          <div className="mt-10 px-10">
            <div
              className="text-center bg-gray-100 border-gray-400 
                border-2 rounded-2xl p-5"
            >
              Changes will not affect your active lease.
            </div>
          </div>
        )}
    </form>
  );
};

export default EditRoomForm;
